import { Link } from 'react-router-dom';

const hotTags = ['最新电影', '4K蓝光', '无损音乐', '3A大作', '编程教程', '日漫新番'];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20connections%20with%20warm%20orange%20and%20amber%20gradient%20geometric%20patterns%2C%20flowing%20data%20streams%20in%20dark%20space%2C%20modern%20technology%20mood%20with%20soft%20glowing%20nodes%2C%20futuristic%20minimal%20aesthetic%2C%20clean%20composition%20with%20subtle%20grid%20overlay%2C%204k%20quality&width=1800&height=900&seq=hero-magnet-bg&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-background-50/90">已收录 1,280+ 优质磁力网站</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          全网磁力网站，一站导航
        </h1>
        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          精选优质磁力搜索网站，覆盖影视、软件、游戏、音乐等全品类资源。
          最新、最快、最稳定的磁力网站导航，让资源查找变得简单高效。
        </p>

        <div className="relative max-w-xl mx-auto mb-6">
          <div className="flex items-center bg-background-50 rounded-xl overflow-hidden">
            <div className="flex items-center pl-4 text-foreground-400">
              <i className="ri-search-line text-lg"></i>
            </div>
            <input
              type="text"
              placeholder="输入关键词搜索磁力网站..."
              className="flex-1 px-3 py-4 text-sm text-foreground-900 bg-transparent outline-none placeholder:text-foreground-400"
            />
            <button className="px-6 py-4 bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              搜索磁力
            </button>
          </div>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2">
          <span className="text-sm text-background-50/60">热门搜索：</span>
          {hotTags.map(tag => (
            <Link
              key={tag}
              to={`/category/yingshi`}
              className="px-3 py-1 rounded-full bg-background-50/10 border border-background-50/15 text-sm text-background-50/80 hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}